import { CaptureTreeEntityRevision } from "@faro-lotv/service-wires";
import { createContext, useContext } from "react";

export const ConnectedEntitiesGroupsContext = createContext<
  CaptureTreeEntityRevision[][]
>([]);

/**
 * Provides the connected entities groups context.
 * This context is used to group entities that are connected together in the UI.
 * It is typically used in the ActionsPanel to display groups of connected entities that require review.
 *
 * @returns An array of arrays of CaptureTreeEntityRevision representing groups of connected entities.
 */
export function useConnectedEntitiesGroups(): CaptureTreeEntityRevision[][] {
  return useContext(ConnectedEntitiesGroupsContext);
}
